// Données structurées (JSON-LD) : la fiche de l'entreprise sur toutes les pages (ajoutée par scripts/prerender.mjs),
// et les morceaux propres à une page (fil d'Ariane, FAQ, service), passés à usePageMeta.
import { company, type Locale } from './content'
import { SITE } from './site-pages'
import type { Question } from './villes'

export const entreprise = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${SITE}/#entreprise`,
  name: 'COGETRANS',
  description: 'Transitaire agréé en douane (agrément n° 0318) : transit, dédouanement et accompagnement des opérations d’import-export au Maroc depuis 2003.',
  url: `${SITE}/fr`,
  logo: `${SITE}/assets/cogetrans-logo-sombre.png`,
  image: `${SITE}/assets/hero-port.webp`,
  foundingDate: '2003',
  address: { '@type': 'PostalAddress', streetAddress: company.rue, addressLocality: 'Casablanca', addressCountry: 'MA' },
  areaServed: { '@type': 'Country', name: 'Maroc' },
  knowsAbout: ['Transit', 'Dédouanement', 'Import-export', 'Fret maritime', 'Fret aérien', 'Transport routier'],
  telephone: company.phones[0].link,
  faxNumber: '+212522407053',
  email: company.email,
  identifier: [{ '@type': 'PropertyValue', name: 'ICE', value: company.legal.ice }, { '@type': 'PropertyValue', name: 'RC Casablanca', value: company.legal.rc }],
  contactPoint: company.phones.map(t => ({ '@type': 'ContactPoint', telephone: t.link, contactType: 'customer service', areaServed: 'MA', availableLanguage: ['French', 'Arabic'] })),
})

// Fil d'Ariane : [['Accueil', ''], ['Services', '/services'], …]
export const ariane = (locale: Locale, etapes: [string, string][]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: etapes.map(([name, path], i) => ({ '@type': 'ListItem', position: i + 1, name, item: `${SITE}/${locale}${path}` })),
})

// La FAQ telle qu'elle est écrite sur la page, mot pour mot.
export const pageFaq = (questions: Question[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: questions.map(({ q, r }) => ({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: r } })),
})

export const service = (nom: string, description: string, zone = 'Maroc') => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: nom,
  description,
  serviceType: nom,
  provider: { '@id': `${SITE}/#entreprise` },
  areaServed: { '@type': 'Place', name: zone },
})
